module.exports = __webpack_public_path__ + "media/images/shared/muevo_voice_log_with_text-7ed68f643e7c3cf15217c34a32ce2ca9.png";